import React, { useContext } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { IDishesContext, DishesContext } from '../../dishesState/dishesContext';
import { DishesByCustomerList } from './DishesByCustomerList';
import { DishesByRestaurantList } from './DishesByRestaurantList';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import style from './Dishes.module.scss';

export const Dishes: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, dishesByCustomer, dishesByRestaurant, currentPage, countOfItems } =
		useContext<IDishesContext>(DishesContext);

	return (
		<>
			{dishesByCustomer.totalCount || dishesByRestaurant.totalCount ? (
				<div className={style.container} data-test="Dishes">
					{!!dishesByCustomer.totalCount && <DishesByCustomerList />}
					{!!dishesByRestaurant.totalCount && <DishesByRestaurantList />}
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={dishesByCustomer.totalCount || dishesByRestaurant.totalCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};
